export class SelectPatientRelationshipModel{
    patientRelationship: number = 0;
    patientIdRelationship: number = 0;
}